module.exports = __webpack_public_path__ + "img/1515344641.f2dabe10.jpg";